// Targetable tiers (Bronze is below Noir's minimum, intentionally not listed).
export const TIERS = ['Silver', 'Gold', 'Black'];

// Mirrors packages/server/src/tiers/shopper_tier_data.js. Each tier covers the score band
// up to (but not including) the next tier's minScore.
export const TIER_SCORE_RANGE = {
  Silver: [30, 69],
  Gold: [70, 84],
  Black: [85, 100]
};

// Returns the union span of the selected tier ranges, or [0, 100] when none selected.
export const scoreRangeForTiers = selectedTiers => {
  if (selectedTiers.length === 0) return [0, 100];
  const ranges = selectedTiers.map(t => TIER_SCORE_RANGE[t]).filter(Boolean);
  return [Math.min(...ranges.map(r => r[0])), Math.max(...ranges.map(r => r[1]))];
};

// Creators and shoppers both have Noir access; this filter lets a broadcast target one or both.
// Maps to Users.isShopper (1 = shopper, 0 = creator).
export const USER_TYPE_OPTIONS = [
  { value: 'both', label: 'Both (creators + shoppers)' },
  { value: 'shopper', label: 'Shoppers only' },
  { value: 'creator', label: 'Creators only' }
];

export const NOIR_STATUSES = [
  { value: 'any', label: 'Any' },
  { value: 'no_request', label: 'No request (has thread, no request submitted)' },
  { value: 'requested', label: 'Submitted request' }
];

// Buckets are mutually exclusive and match the shopper-list "Purchase Status" column 1:1.
export const PURCHASE_OPTIONS = [
  { value: 'any', label: 'Any', desc: 'No purchase filter — include everyone regardless of purchases.' },
  {
    value: 'general',
    label: 'General purchase only',
    desc: "Bought through another creator's link, with NO purchase tied to a Noir recommendation."
  },
  {
    value: 'noir',
    label: 'Noir purchase only',
    desc: 'Bought from a collection recommended on their own Noir request, with no separate non-Noir purchase.'
  },
  {
    value: 'both',
    label: 'Both general & Noir',
    desc: 'Made a Noir-recommendation purchase AND a separate non-Noir purchase.'
  },
  { value: 'none', label: 'No purchases yet', desc: 'No qualifying purchases of either kind.' }
];

export const ENGAGEMENT_TYPES = [
  ['any', 'Any'],
  ['requests', 'Requests'],
  ['approvals', 'Approvals'],
  ['approved_not_converted', 'Approved, no purchase']
];

export const CODE_LOGIC_OPTIONS = [
  ['any', 'Used any'],
  ['all', 'Used all'],
  ['none', 'Used none']
];

export const MERGE_FIELDS = [
  ['{{first_name}}', 'First Name'],
  ['{{tier_name}}', 'Tier Name']
];
